import React, { useEffect, useState, useMemo } from 'react';
import { Grid } from '@mui/material';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import './stepCondicionesGenerales.scss';

export const StepCondicionesGenerales2 = ({
	selectedPrograms,
	setDataSubmissionCallback,
	updateFormData,
	fullFormDataRI,
	programOnlyCP,
}) => {
	const [condicionesGenerales, setCondicionesGenerales] = useState(fullFormDataRI?.condicionesGenerales2 ?? {});

	const handleSubmit = () => {
		updateFormData('condicionesGenerales2', condicionesGenerales, validatedinputsGroups.flatMap(x => x.inputs));
	}

	const handleChange = (name, value) => {
		setCondicionesGenerales(prevDatos => ({
			...prevDatos,
			[name]: value
		}))
	}

	const validatedinputsGroups = useMemo(() => {

		const updatedRequired = structuredClone(inputsGroups).map(group => ({
			...group,
			inputs: group.inputs.map(input => {
				switch (input.name) {
					case 'prestacion':
					case 'empresa':
						input.required = condicionesGenerales?.internacionDomiciliaria;
						break;
					case 'comprendeAceptaServicio':
					case 'higiene':
						input.hidden = programOnlyCP;
						input.required = !programOnlyCP;
						break;
					default:
						break;
				}
				if (input.type === 'select' || (typeof input.type === 'string' && input.type.includes('multiple'))) {
					input.options = getOptionsByName(input.name);
				}
				return input;
			})
		}))

		return updatedRequired;
	}, [selectedPrograms, condicionesGenerales?.internacionDomiciliaria, programOnlyCP]);


	useEffect(() => {
		setDataSubmissionCallback(handleSubmit);
	}, [condicionesGenerales, setDataSubmissionCallback, validatedinputsGroups]);

	useEffect(() => {
		if (!programOnlyCP) return;
		setCondicionesGenerales(prevDatos => ({
			...prevDatos,
			comprendeAceptaServicio: null,
			higiene: null,
		}));
	}, [programOnlyCP]);


	const getOptionsByName = (fieldName) => {
		const combos = {};

		return combos[fieldName] || [];
	}

	return (
		<div>
			{validatedinputsGroups.map(group => (
				<div className='step-form-section-container' key={group.groupName}>
					<label className='step-form-section-title'>{group.groupName}</label>
					<Grid
						container>
						{group.inputs
							.filter(input => !input.hidden)
							.map((input) => {
								return (
									<RenderInputByTypeMobile
										key={`${group.groupName}-${input.name}`}
										grided
										handleChange={handleChange}
										input={input}
										value={condicionesGenerales[input.name]}
									/>
								)
							})}
					</Grid>
				</div>
			))
			}
		</div>
	)
}

export default StepCondicionesGenerales2;

const inputsGroups = [
	{
		groupName: 'Condiciones del domicilio según referencia paciente/cuidador',
		inputs: [
			{
				displayName: 'Domicilio accesible?',
				name: 'domicilioAccesible',
				type: 'boolean',
				required: true,
			},
			{
				displayName: 'Agua potable?',
				name: 'aguaPotable',
				type: 'boolean',
				required: true,
			},
			{
				displayName: 'Red eléctrica?',
				name: 'redElectrica',
				type: 'boolean',
				required: true,
			},
			{
				displayName: 'Paciente/familiar comprende y acepta el servicio?',
				name: 'comprendeAceptaServicio',
				type: 'boolean',
				required: true,
			},
			{
				displayName: 'Higiene del domicilio aceptable?',
				name: 'higiene',
				type: 'boolean',
				required: true,
			},
			{
				displayName: 'Lugar seguro para el almacenamiento?',
				name: 'almacenamiento',
				type: 'boolean',
				required: true,
			},
			{
				displayName: 'Cuidadores en domicilio?',
				name: 'cuidador',
				type: 'boolean',
				required: true,
			},
			{
				displayName: 'Tiene internación domiciliaria?',
				name: 'internacionDomiciliaria',
				type: 'boolean',
				required: true,
			},
			{
				displayName: 'Prestación que recibe?',
				name: 'prestacion',
				type: 'string',
				required: true,
			},
			{
				displayName: 'Empresa que se lo realiza?',
				name: 'empresa',
				type: 'string',
				required: true,
			},
			{
				displayName: 'Observaciones',
				name: 'observaciones',
				type: 'string',
				required: false,
			},
		]
	}
];





